import React, { useEffect, useState } from "react";
import axios from "axios";

const API = "http://localhost:5000/api/banners";

export default function PromoBannerManager() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [editId, setEditId] = useState(null);
  const [image, setImage] = useState(null);

  const [form, setForm] = useState({
    brand: "",
    title: "",
    textColor:"#000000",
    subtitle: "",
    bgColor: "#ffffff",
    link: "",
    position: 0,
    isActive: true
  });

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    setLoading(true);
    const res = await axios.get(API);
    setBanners(res.data.data);
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const resetForm = () => {
    setForm({
      brand: "",
      title: "",
      subtitle: "",
      textColor:"#000000",
      bgColor: "#ffffff",
      link: "",
      position: 0,
      isActive: true
    });
    setImage(null);
    setEditId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const formData = new FormData();
    Object.keys(form).forEach((key) => formData.append(key, form[key]));
    if (image) formData.append("image", image);

    if (editId) {
      await axios.put(`${API}/${editId}`, formData);
    } else {
      await axios.post(API, formData);
    }

    resetForm();
    fetchBanners();
    setSubmitting(false);
  };

  const handleEdit = (b) => {
    setForm({
      brand: b.brand,
      textColor:b.textColor,
      title: b.title,
      subtitle: b.subtitle,
      bgColor: b.bgColor,
      link: b.link,
      position: b.position,
      isActive: b.isActive
    });
    setEditId(b._id);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this banner?")) {
      await axios.delete(`${API}/${id}`);
      fetchBanners();
    }
  };

  return (
    <div className="container my-4">
      {/* FORM */}
      <div className="card shadow-sm mb-4">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">{editId ? "Update Banner" : "Create Banner"}</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label">Brand</label>
                <input className="form-control" name="brand" value={form.brand} onChange={handleChange} required />
              </div>

              <div className="col-md-4">
                <label className="form-label">Title</label>
                <input className="form-control" name="title" value={form.title} onChange={handleChange} required />
              </div>

              <div className="col-md-4">
                <label className="form-label">Subtitle</label>
                <input className="form-control" name="subtitle" value={form.subtitle} onChange={handleChange} />
              </div>

              <div className="col-md-3">
                <label className="form-label">Background Color</label>
                <input type="color" className="form-control form-control-color" name="bgColor" value={form.bgColor} onChange={handleChange} />
              </div>
              
              <div className="col-md-3">
                <label className="form-label">Text Color</label>
                <input type="color" className="form-control form-control-color" name="textColor" value={form.textColor} onChange={handleChange} />
              </div>

              <div className="col-md-3">
                <label className="form-label">Position</label>
                <input type="number" className="form-control" name="position" value={form.position} onChange={handleChange} />
              </div>

              <div className="col-md-3">
                <label className="form-label">Link</label>
                <input className="form-control" name="link" value={form.link} onChange={handleChange} />
              </div>

              <div className="col-md-3">
                <label className="form-label">Image</label>
                <input type="file" className="form-control" onChange={(e) => setImage(e.target.files[0])} />
              </div>

              <div className="col-12">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="isActive" checked={form.isActive} onChange={handleChange} />
                  <label className="form-check-label">Active</label>
                </div>
              </div>

              <div className="col-12 d-flex gap-2">
                <button className="btn btn-success" disabled={submitting}>
                  {submitting && <span className="spinner-border spinner-border-sm me-2"></span>}
                  {editId ? "Update" : "Create"}
                </button>
                {editId && (
                  <button type="button" className="btn btn-secondary" onClick={resetForm}>
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* LIST */}
      <div className="card shadow-sm">
        <div className="card-header bg-dark text-white">
          <h5 className="mb-0">Banner List</h5>
        </div>

        <div className="table-responsive">
          <table className="table align-middle table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th>Preview</th>
                <th>Brand</th>
                <th>Title</th>
                <th>Status</th>
                <th width="160">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan="5" className="text-center py-4">
                    <div className="spinner-border text-primary"></div>
                  </td>
                </tr>
              )}

              {!loading &&
                banners.map((b) => (
                  <tr key={b._id}>
                    <td>
                      <div className="card p-2" style={{ backgroundColor: b.bgColor, maxWidth: 250 }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <small className="fw-bold">{b.brand}</small>
                            <div>{b.title}</div>
                          </div>
                          <img src={b.image} alt="" height="50" />
                        </div>
                      </div>
                    </td>
                    <td>{b.brand}</td>
                    <td>{b.title}</td>
                    <td>
                      <span className={`badge ${b.isActive ? "bg-success" : "bg-secondary"}`}>
                        {b.isActive ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <div className="btn-group btn-group-sm">
                        <button className="btn btn-warning" onClick={() => handleEdit(b)}>Edit</button>
                        <button className="btn btn-danger" onClick={() => handleDelete(b._id)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))}

              {!loading && !banners.length && (
                <tr>
                  <td colSpan="5" className="text-center text-muted py-4">
                    No banners found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
